import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const Merge = (props: SvgIconT.Props) => (
  <SvgIcon width={24} {...props} viewBox="0 0 24 24">
    <path d="M18.49 17c-.025-.002-2.937.04-4.831-1.815-1.1-1.079-1.659-2.599-1.659-4.52V5.707l2.147 2.146a.5.5 0 00.707-.707l-3-3a.5.5 0 00-.707 0l-3 3a.5.5 0 10.707.707L11 5.707v4.958c0 1.921-.558 3.441-1.658 4.52C7.446 17.04 4.53 16.997 4.512 17c-.328.002-.505.214-.512.49a.5.5 0 00.488.51h.063c.481 0 3.426-.085 5.484-2.095a6.155 6.155 0 001.465-2.257c.328.87.817 1.624 1.465 2.257C15.024 17.916 17.968 18 18.45 18h.063c.276-.007.494-.235.488-.51s-.192-.487-.51-.49z"></path>
  </SvgIcon>
);

export default Merge;
